import React from "react";
import styled from "styled-components";

// context
import { usePhotoModBatches } from "frontend/components/fort/mod/photos/hooks/usePhotoModBatches";

// components
import Button from "core/Button";

// styles
import { convertPxToRem } from "frontend/components/helpers";

export const LoadMoreButtonStyled = styled.div`
    text-align: center;
    margin: ${convertPxToRem(50)} 0px;
`;

// component
export const LoadMoreButton = () => {
    const {
        ids: batches,
        pagination,
        apiCall,
        apiStatus,
        showLoading
    } = usePhotoModBatches();
    const {
        currentPage,
        batchesPerPage,
        totalCount,
        remainder,
        isSecondToLastPage,
        isLastPage
    } = pagination;

    const onClick = () => {
        apiCall(currentPage + 1);
    };

    // only show Load More if there is more than one page of data
    if (!batches || showLoading || isLastPage) return null;

    let text = `Load next ${batchesPerPage} of ${totalCount}`;
    if (isSecondToLastPage) {
        text = `Load last ${remainder} of ${totalCount}`;
    }

    return (
        <LoadMoreButtonStyled>
            <Button
                onClick={onClick}
                isProcessing={apiStatus === "calling-api"}
            >
                {text}
            </Button>
        </LoadMoreButtonStyled>
    );
};

export default LoadMoreButton;
